import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';

import { brokeredOrderCalculateMarginsQueryAtom } from '../_graphql/queryBrokeredOrderCalculateMargins';
import { ItemMarginRecord } from '../types/brokeredOrder';

type MarginsParams = {
  purchaseOrderIds: string[];
  salesOrderIds: string[];
};

const createParamsKey = (params: MarginsParams): string =>
  `${[...params.purchaseOrderIds].sort().join(',')}_${[...params.salesOrderIds].sort().join(',')}`;

export const $brokeredOrderMarginsByParams = atomFamily(
  (params: MarginsParams) =>
    brokeredOrderCalculateMarginsQueryAtom(() => ({
      variables: {
        purchaseOrderIds: params.purchaseOrderIds,
        salesOrderIds: params.salesOrderIds,
        method: 'WeightedAverage',
      },
      skip:
        params.purchaseOrderIds.length === 0 &&
        params.salesOrderIds.length === 0,
    })),
  (a, b) => createParamsKey(a) === createParamsKey(b),
);

export const $brokeredOrderMarginsDataByParams = atomFamily(
  (params: MarginsParams) =>
    atom((get): ItemMarginRecord[] => {
      const margins = get($brokeredOrderMarginsByParams(params));
      return margins?.data ?? [];
    }),
  (a, b) => createParamsKey(a) === createParamsKey(b),
);
